// extracted by mini-css-extract-plugin
export default {"message":"page-header_message__7pnjm","title":"page-header_title__I5weu","email":"page-header_email__e8S1B"};